<div class="p-4 space-y-3">
  <h3 class="text-base font-semibold text-gray-800">{{ title }}</h3>

  @if (rows.length > 0) {
    <div class="max-h-[420px] overflow-y-auto space-y-2">
      @for (row of rows; track $index) {
        <div class="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
          <p class="text-xs text-slate-500">{{ row.date }}</p>
          <p class="text-sm text-slate-800">{{ row.summary }}</p>
        </div>
      }
    </div>
  } @else {
    <p class="text-sm text-slate-500 italic">Aucun historique disponible.</p>
  }

  <div class="flex justify-end">
    <button type="button" class="btn btn-ghost btn-sm" (click)="close()">Fermer</button>
  </div>
</div>
